var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChervonDown = function SvgChervonDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.538.5 3.88 3.88L10.298.5a.996.996 0 1 1 1.41 1.41L7.118 6.5a.996.996 0 0 1-1.41 0l-4.59-4.59a.996.996 0 0 1 0-1.41c.39-.38 1.03-.39 1.42 0"
  })));
};
export default SvgChervonDown;